import forOwn from 'mout/object/forOwn'
import sortByPropText from '../content/manageSets/sortByPropText'

function expandSet (sortedContent, sets) {
  let items = []
  sortedContent.forEach((itemOrSet) => {
    if (!sets[itemOrSet.id] && itemOrSet.active) {
      items.push(itemOrSet.id)
    } else if (itemOrSet.active) {
      let setItems = []
      forOwn(sets[itemOrSet.id].content, (val, key, o) => {
        if (val.active) {
          setItems.push({
            id: key,
            active: val.active,
            index: val.index
          })
        }
      })
      const sortedSetItems = sortByPropText(setItems, 'index')
      sortedSetItems.forEach((sortedSetItem) => {
        if (sortedSetItem.active) {
          items.push(sortedSetItem.id)
        }
      })
    }
  })
  return items
}

function arraysEqualQ(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false
  }
  for (var i = arr1.length; i--;) {
    if (arr1[i] !== arr2[i]) {
      return false
    }
  }
  return true
}

function expandSetId(sets, setId) {
  let expandedSet = []
  if (sets[setId]) {
    let setItems = []
    forOwn(sets[setId].content, (val, key, o) => {
      if (val.active) {
        setItems.push({
          id: key,
          active: val.active,
          index: val.index,
        })
      }
    })
    const sortedSetItems = sortByPropText(setItems, 'index')
    sortedSetItems.forEach((sortedSetItem) => {
      if (sortedSetItem.active) {
        expandedSet.push(sortedSetItem.id)
      }
    })
    return expandedSet
  } else {
    return [setId]
  }
}


function expandSetCompletely(sortedContent, sets) {
  let items = expandSet(sortedContent, sets)
  let check = []
  
  // expands sets in the array until there aren't any more sets in the array
  do {
    check = items.slice(0)
    let newItemList = []
    items.forEach((item) => {
      if (!sets[item]) {
        newItemList.push(item)
      } else {
        const expandedSet = expandSetId(sets, item)
        expandedSet.forEach((newItem) => {
          newItemList.push(newItem)
        })
      }
    })
    items = newItemList.slice(0)
  }
  while (!arraysEqualQ(check, items))
  
  return items

}

/**
 * Converts subtests into object with array of item id's for each subtest.
 * @param {object} sets All of the sets in db.collection('sets').
 * @param {object} assessmentSubtests The assessment subtest set objects.
 * @returns {object} Key subtest id with prop items including array of all item ids. Sub-sets fully expanded.
 */
export default function destructureSubtests(sets, assessmentSubtests) {
  let destructuredSubtests = {}
  forOwn(assessmentSubtests, (subVal, subKey, subObj) => {
    destructuredSubtests[subKey] = {}
    let contentToSort = []
    forOwn(subVal.content, (val, key, o) => {
      contentToSort.push({
        id: key,
        ...val
      })
    })
    const sortedContent = sortByPropText(contentToSort, 'index')

    const expandedSet = expandSetCompletely(sortedContent, sets)

    destructuredSubtests[subKey].items = expandedSet

  })
  return destructuredSubtests
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/destructureSubtests.js